(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('PeriodoService', PeriodoService);

  function PeriodoService() {

    var service = {
      loadPeriodosFiltro : loadPeriodosFiltro,
      carregaAnosValidosAte: carregaAnosValidosAte
    };

    return service;

    function loadPeriodosFiltro(sort='asc') {

      var dataLimiteFinal = new Date(moment().format('YYYY'), moment().format('MM') - 3, 1);

      var dataInicial= new Date(moment().format('YYYY'), moment().format('MM') - 13, 1);

      var periodoRelatorioEnviadoList = [];

      if(sort === 'asc') {
        while(dataInicial <= dataLimiteFinal) {
          periodoRelatorioEnviadoList.push(retornaDataFormatada(dataInicial));
          dataInicial = new Date(dataInicial.getFullYear(), dataInicial.getMonth() + 1, 1);
        }
      }
      if(sort === 'desc') {
        while(dataLimiteFinal >= dataInicial) {
          periodoRelatorioEnviadoList.push(retornaDataFormatada(dataLimiteFinal));
          dataLimiteFinal = new Date(dataLimiteFinal.getFullYear(), dataLimiteFinal.getMonth() - 1, 1);
        }
      }

      function retornaDataFormatada(data) {
        var mes = (data.getMonth() + 1).toString();
        return data.getFullYear().toString() + (mes.length === 1 ? '0' + mes : mes);
      }

      return periodoRelatorioEnviadoList;
    }

    function carregaAnosValidosAte(anoBase) {
      let anoList = [];

      if(typeof anoBase !== 'number' || anoBase<0) {
        throw new Error("anoBase deve ser de tipo number e positivo");
      }

      let anoAtualValido =  parseInt(moment().subtract(2, 'months').format("YYYY"));
      if(anoAtualValido < anoBase) {
        throw new Error("anoBase deve ser anterior que o ano atual");
      }

      for(let contador=anoAtualValido; anoBase <= contador; contador--) {
        console.log(contador);
        anoList.push(contador);
      }

      return anoList;

    }
  }
})();
